import { render, staticRenderFns } from "./HomeExaminationInfo.vue?vue&type=template&id=8d902f20&scoped=true&"
import script from "./HomeExaminationInfo.vue?vue&type=script&lang=js&"
export * from "./HomeExaminationInfo.vue?vue&type=script&lang=js&"
import style0 from "./HomeExaminationInfo.vue?vue&type=style&index=0&id=8d902f20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d902f20",
  null
  
)

export default component.exports